module.exports = " <div class=\"btn btn-primary\" style=background:#fff;border:0> <div id=fdt_login ng-init=$ctrl.loadButton()></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/google-sso-button/google-sso-button.html
// module id = 387
// module chunks = 0